/**
 * 081f-e401 - UnlicensedSNES
 */
module.exports = {
    padID: '081f-e401',
    padType: 'snes',
    gamepadMapping : {
        RC_S: 2,
        RC_E: 1,
        RC_W: 3,
        RC_N: 0,
        START: 9,
        SELECT: 8,
        LB: 4,
        RB: 5,
        LC_N: 12,
        LC_S: 13,
        LC_W: 14,
        LC_E: 15
    }
}